//#region src/date-picker/types/date-mode-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.DateSince = "dateSince", e.DateTill = "dateTill", e;
}({});
//#endregion
export { e as DateModeEnum };
